import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { ParticipantVerificationStatus } from '../../models/auth/ParticipantVerificationStatus';

const styles = () => ({
  label: {
    textAlign: 'center',
    padding: 2,
    border: '1px solid',
    borderRadius: 4,
    fontWeight: 500,
    color: '#fff',
    letterSpacing: 0.1,
    textTransform: 'uppercase',
    fontSize: 12,
  },
  notVerified: {
    borderColor: '#FB8C00',
    backgroundColor: '#FB8C00',
  },
  verified: {
    borderColor: '#00C853',
    backgroundColor: '#00C853',
  },
  verifying: {
    color: '#000',
    borderColor: '#e0e0e0',
    backgroundColor: '#e0e0e0',
  },
});

const ParticipantAccountStatusLabel = ({ t, classes, status }) => (
  <span className={classNames(classes.label, classes[status])}>{t(`auth.participantAccounts.participantVerificationStatus.${status}`)}</span>
);

ParticipantAccountStatusLabel.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  status: PropTypes.oneOf(Object.keys(ParticipantVerificationStatus)),
};

export default compose(
  withStyles(styles),
  translate())(ParticipantAccountStatusLabel);



// WEBPACK FOOTER //
// ./src/components/userProfile/ParticipantAccountStatusLabel.js